import React from "react";
import PropTypes from "prop-types";
import { CloseOutlined, EditOutlined } from "@mui/icons-material";
import { Divider, Drawer, IconButton, Tooltip } from "@mui/material";

import PermissionIconButton from "components/shared/PermissionIconButton/PermissionIconButton";
import StatusChip from "components/shared/StatusChip/StatusChip";
import { PERMISSIONS } from "utils/accessManagement/permissionKeys";
import { formatRoleLabel } from "utils/accessManagement/roleDisplay";

import PermissionGroupList from "./PermissionGroupList";

import "pages/ecrOps/OrgEditDrawer.css";

const RoleDetailDrawer = ({ role, canUpdate, onClose, onEdit }) => {
  if (!role) return null;

  return (
    <Drawer anchor="right" open={!!role} onClose={onClose} PaperProps={{ sx: { width: { xs: "100%", sm: 520 } } }}>
      <div className="org-drawer__header">
        <div className="org-drawer__header-text">
          <p className="org-drawer__header-eyebrow">Role</p>
          <h2 className="org-drawer__header-title">{formatRoleLabel(role.role_name)}</h2>
          <code className="org-drawer__header-id">{role.id}</code>
        </div>
        <Tooltip title="Close">
          <IconButton size="small" onClick={onClose} sx={{ color: "#9ca3af" }}>
            <CloseOutlined />
          </IconButton>
        </Tooltip>
      </div>

      <div className="org-drawer__body">
        <div className="org-drawer__section">
          <div style={{ display: "flex", gap: 24 }}>
            <div>
              <p style={{ fontSize: "11px", color: "#9ca3af", margin: "0 0 4px" }}>Status</p>
              <StatusChip isActive={role.is_active !== false} />
            </div>
            <div>
              <p style={{ fontSize: "11px", color: "#9ca3af", margin: "0 0 4px" }}>Priority</p>
              <span style={{ fontSize: "14px", fontWeight: 700 }}>{role.priority ?? "—"}</span>
            </div>
            <div>
              <p style={{ fontSize: "11px", color: "#9ca3af", margin: "0 0 4px" }}>Permissions</p>
              <span style={{ fontSize: "14px", fontWeight: 700 }}>{(role.permissions || []).length}</span>
            </div>
          </div>
          {role.description && <p style={{ fontSize: "13px", color: "#374151", marginTop: 16 }}>{role.description}</p>}
        </div>

        <Divider />

        <div className="org-drawer__section">
          <p className="org-drawer__section-title">Permissions by resource</p>
          <PermissionGroupList permissions={role.permissions || []} />
        </div>
      </div>

      <div className="org-drawer__footer">
        <PermissionIconButton
          hasPermission={canUpdate}
          permissionLabel={PERMISSIONS.ROLES_UPDATE}
          tooltip="Edit role"
          ariaLabel="Edit role"
          icon={<EditOutlined fontSize="small" />}
          onClick={() => onEdit(role)}
        />
      </div>
    </Drawer>
  );
};

RoleDetailDrawer.propTypes = {
  role: PropTypes.object,
  canUpdate: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default RoleDetailDrawer;
